export const CommentEN = {
  "Comment": {
    "comment": "Comment",
    "like" : "Like",
    "replyTo" : "Reply to",
    "closeReply" : "Close reply",
    "update" : "Update Comment",
    "delete" : "Delete Comment",
    "cancel" : "press to cancel"
  },
  "Value": {
    "justNow": " just now",
    "minutesAgo" : " minutes ago",
    "daysAgo" : " days ago",
    "hoursAgo" : " hours ago",
    "monthsAgo" : " months ago",
    "writeDiscussion" : "Write Discussion......"
  },
  "InformationComment": {
    "delete": "Comment removed",
    "question" : " Do you really want to delete this comment? ",
    "information" : "CONFIRM",
    "content" : "Content not entered",
    "seeMore" : "See more ",
    "olderComment": "older comment"
  },
  "emoji" : {
    "like" : "Like",
    "heart" : "Heart",
    "haha" : "Ha Ha",
    "wow" : "Wow",
    "sad" : "Sad",
    "angry" : "Angry"
  }
}